@if (dependantDataLoaded) {
  <div class="file-upload-wrapper">
    <mat-toolbar>
      <mat-toolbar-row>
        <div class="file-addto-actions" [formGroup]="form">
          <div class="add-to-button-container">
            @if (form.get('ipType')?.value; as ipType) {
              <div class="selected-ip-icon">
                <ip-icon [ipType]="ipType"></ip-icon>
              </div>
            }
            <button mat-flat-button color="primary" [matMenuTriggerFor]="addToMenu">
              Add To ... <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
            </button>
          </div>
          <mat-menu #addToMenu="matMenu">
            @for (type of ipTypes; track type) {
              @if (hasUploadPermission(type.key)) {
                <button mat-menu-item (click)="onAddToClick(type.key)"><ip-icon [ipType]="type.key"></ip-icon> {{ type.value }}</button>
              }
            }
          </mat-menu>
          @if (form.get('ipType')?.value !== null) {
            @if (form.get('search'); as ctrl) {
              <div class="toolbar-input-field">
                <input
                  matInput
                  formControlName="search"
                  [matAutocomplete]="autocomplete.matAutocomplete"
                  aria-label="Search for cases"
                  [placeholder]="placeholderText"
                  autocomplete="nope"
                />
              </div>
            }
            <!--
            Paginated Autocomplete Component with Checkbox Selection
            Inputs:
            - isInUploaderComponent: Boolean flag indicating component is used in uploader context
            - searchItems$: Observable stream of search result items
            - displayFn: Function that formats how each option appears in dropdown
            - showCheckboxes: Boolean to display checkboxes for multi-select
            - selectedItems: Array of currently selected items
            - paginationInfo$: Observable containing pagination metadata
            Outputs:
            - optionSelected: Emits when user selects an autocomplete option
            - checkboxChange: Emits when checkbox selection changes with event and item
            - pageChange: Emits when user changes results page
            Template Variables:
            - item: Current item in the iteration
            - showCheckboxes: Boolean for checkbox visibility
            - isSelected: Boolean indicating if current item is selected
            Local Reference:
            #autocomplete: Provides access to component's MatAutocomplete instance
            -->
            <app-paginated-autocomplete
              #autocomplete
              [isInUploaderComponent]="true"
              [searchItems$]="searchItems$"
              [displayFn]="searchDisplayFn"
              [showCheckboxes]="true"
              [isAll]="false"
              [selectedItems]="selectedItemsForAutocomplete"
              [paginationInfo$]="paginationInfo$"
              (optionSelected)="onSearchSelectionChange($event)"
              (checkboxChange)="onCheckboxChange($event.event, $event.item)"
              (pageChange)="onPageChange($event)"
            >
              <ng-template let-item let-showCheckboxes="showCheckboxes" let-isSelected="isSelected">
                <div class="search-item">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="onCheckboxChange($event, item)"
                    [checked]="isItemSelected(item)"
                  >
                  </mat-checkbox>
                  <div class="search-item-content">
                    <div class="search-item-title">
                      <ip-icon [ipType]="item.ipType"></ip-icon>
                      {{ item.identifier }}
                      @if (item.serial && item.serial.trim() !== '') {
                        | <small>SN: {{ item.serial }}</small>
                      }
                    </div>
                    <div class="search-item-subtitle">Title: {{ item.title }}</div>
                  </div>
                </div>
              </ng-template>
            </app-paginated-autocomplete>
          }
        </div>
        <div class="file-upload-actions">
          <button
            [disabled]="uploadTableForms.invalid || uploadTableForms.pending || uploadInitiated"
            mat-flat-button
            color="primary"
            (click)="onUploadFiles()"
          >
            Start Upload
          </button>
          <!-- Progress display -->
          @if (uploadedFilesProgress || skippedFilesProgress) {
            <div class="progress-overlay">
              <div class="progress-container">
                <mat-progress-bar mode="determinate" [value]="progressPercentage"></mat-progress-bar>
                <div class="progress-text">
                  @if (uploadedFilesProgress) {
                    {{ uploadedFilesProgress }}
                  }
                  @if (skippedFilesProgress) {
                    <br />{{ skippedFilesProgress }}
                  }
                </div>
              </div>
            </div>
          }
          <button type="button" mat-flat-button color="primary" (click)="uploader.click()">Browse Files</button>
          <input hidden="hidden" multiple="multiple" type="file" #uploader (change)="onBrowseFiles($event)" />
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="files-container">
      @for (formGroup of uploadTableForms.controls; track formGroup) {
        <app-upload-table
          [form]="formGroup"
          [relFileGroup]="getRelatedFileGroupByTableId(formGroup.get('id')!.value)"
          [allSubTypes]="allSubTypes"
          [trifoldMap]="trifoldMap"
          (openFTF)="onOpenInFTF($event)"
          (openIPMS)="onOpenInIPMS($event)"
          (closeTable)="onCloseTable($event)"
        />
      }
    </div>
  </div>
}
